import { CurrencyAmountModel } from '@marketplace-web/domain/currency-data'

export const SELLER_INSIGHTS_ASSETS_PREFIX = '/assets/seller-insights'
export const SELLER_INSIGHTS_TAB_NAME = 'insights'

export type SellerInsightsType = {
  isVisible: boolean
  activeItemsStats: {
    count: number
    total: CurrencyAmountModel
  }
  soldItemsStats: {
    total: CurrencyAmountModel
    period: {
      total: CurrencyAmountModel
    }
  }
}
